import { gql } from '@apollo/client';
import {
  ErrorMessageInfo,
  SubscriptionInfoShared,
} from '@retainerclub/shared-api';

export default gql`
  mutation actionSubscriptionAdminCancel($input: SubscriptionCancelActionInput!) {
    actionSubscriptionAdminCancel(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      previewData
      subscription {
        ...SubscriptionInfoShared
      }
    }
  }
  ${ErrorMessageInfo}
  ${SubscriptionInfoShared}
`;
